import { useAuth } from '@/composables/useAuth'

export default defineNuxtRouteMiddleware((to, from) => {
	const { cookie } = useAuth()
	if (cookie.value) {
		const routeQuery = from.query || to.query
		return navigateTo(
			{
				path: '/',
				query: routeQuery
			},
			{
				replace: true
			}
		)
	}
})
